// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_ga","galleryItem_borderTopRadius":"c-o_gb","galleryItem__image":"c-o_gc","galleryItem__image_withBlur":"c-o_ge"};